var url = window.location.search;

if ( url.length > 0 ) {
  setTimeout(function(){
    var url = window.location.search;
    url = url.replace("?", '').toLowerCase();
    var element = document.getElementById(url);
    if (!element) {
      return;
    }
    element.click();
  }, 2000)
}

// Make subscription images clickable update
$(".subscription-block-container .slide-button").click(function() {
  $(this).parents('.subscription-block-container').find('.slide-button').removeClass('selected');
  $(this).parent().find('.slide-button').addClass('selected');

  
  if ($(this).hasClass('weekly')) {
    $('.fortnightly-coffee').hide();
    $('.weekly-coffee').show();
  } else if ($(this).hasClass('fortnightly')) {
    $('.fortnightly-coffee').show();
    $('.weekly-coffee').hide();
  }

  const nextSection = $(this).closest('.subscription-section-wrapper').next();
  $(nextSection).slideDown('slow');
  const nextPos = nextSection.offset().top - 20;
  $('html, body').animate({
    scrollTop: nextPos,
  }, 600);
});

$(".slide-button.button-Filter").click(function() {
  $('.Espresso').hide();
  $('.Filter').show();
});

$(".slide-button.button-Espresso").click(function() {
  $('.Filter').hide();  
  $('.Espresso').show();
});
// for recharge
// const SUBSCRIPTION_ID = 283072;

// const getJsonFromScriptTag = (selector, element) => {
//   const scriptEl = element ? element.querySelector(selector) : document.querySelector(selector);
//   if (!scriptEl || scriptEl.nodeName !== 'SCRIPT') return null;
//   const htmlString = scriptEl.innerHTML.trim().replace(/(\r\n|\n|\r)/gm, '');
//   return JSON.parse(htmlString);
// };

// const subscription = {
//   state: {
//     productData: null,
//     coffee: {},
//     type: {},
//     frequency: {},
//     price: 0,
//     variantMatch: null,
//   },
//   init(product) {
//     this.initSelectors();
//     this.state.productData = {...product};
//     const options = ['Type,Coffee'];
//     document.getElementsByName('Type').forEach((el) => {
//       el.addEventListener('click', this.updateSelection.bind(this));
//     });
//     document.getElementsByName('Coffee').forEach((el) => {
//       el.addEventListener('click', this.updateSelection.bind(this));
//     });
//     document.getElementsByName('frequency').forEach((el) => {
//       el.addEventListener('click', this.updateSelection.bind(this));
//     });

//     if (this.checkoutButton) {
//       this.checkoutButton.addEventListener('click', this.addItemToCart.bind(this));
//       // keypress on button also triggering this event listener
//     }
//   },
//   initSelectors() {
//     const dataSelector = 'data-order-summary';
//     this.coffeeSummary = document.querySelector(`[${dataSelector}=coffee]`);
//     this.typeSummary = document.querySelector(`[${dataSelector}=type]`);
//     this.frequencySummary = document.querySelector(`[${dataSelector}=frequency]`);
//     this.priceSummary = document.querySelector(`[${dataSelector}=price]`);
//     this.checkoutButton = document.getElementById('checkout-subscription');
//   },
//   updateOrderSummary(option) {
//     this[`${option}Summary`].textContent = this.state[option].optionLongName;
//   },
//   updateSelection(event) {
//     const option = event.target.name && event.target.name.toLowerCase();
//     if (this.state[option] === event.target.value) {
//       return;
//     }
//     this.state[option] = {
//       ...this.state[option],
//       key: event.target.value,
//       optionLongName: decodeURI(event.target.id),
//     };
//     this.styleSelected(event.target);
//     this.updateOrderSummary(option);
//     this.updateCost();
//     this.goToNextSection(event.target);

//   },
//   goToNextSection(el) {
//     const nextSection = el.closest('.subscription-section-wrapper').nextElementSibling;

//     $(nextSection).slideDown('slow');
//     const nextPos = nextSection.offsetTop;
//     $('html, body').animate({
//       scrollTop: nextPos,
//     }, 600);
//   },
//   styleSelected(el) {
//     const buttonGroup = document.getElementsByName(el.name);
//     // reset group selected
//     el.style.backgroundColor = '#000';
//     el.style.color = '#9ae9ed';
//   },
//   updateCost() {
//     function isEmpty(obj) {
//       return Object.keys(obj).length === 0;
//     }
//     const {frequency, type, coffee, productData} = this.state;
//     console.log(frequency);
//     console.log(type);
//     console.log(coffee);
//     console.log(productData);
//     if (isEmpty(coffee) || isEmpty(type) || isEmpty(frequency) || isEmpty(productData)) {
//       return;
//     }
//     const filters = ['productData', 'frequency', 'price', 'variantMatch'];
//     const selections = Object.keys(this.state)
//       .filter((key) => !filters.includes(key))
//       .map((key) => {
//         return this.state[key].optionLongName;
//       })
//       .filter(Boolean);
//     if (selections.length === 0) {
//       return;
//     }
//     const variantMatch = productData.variants && productData.variants.find((variant) => {
//       return selections.every((selection) => {
//         return variant.options.includes(selection);
//       });
//     });
//     if(variantMatch != undefined){
//       this.state.price = variantMatch.price;
//       this.state.variantMatch = variantMatch;
//       this.priceSummary.textContent = (this.state.price / 100).toLocaleString('en-US', {
//         style: 'currency',
//         currency: 'USD',
//       });
//       this.enableCheckout();
//     }
//   },
//   enableCheckout() {
//     if (!this.checkoutButton) {
//       return;
//     }
//     this.checkoutButton.disabled = false;
//     this.checkoutButton.classList.remove('disabled');
//   },
//   addItemToCart() {
//     const {frequency, units} = this.translateShippingFrequency() || {};
//     const data = {
//       quantity: 1,
//       id: this.state.variantMatch.id,
//       'properties[shipping_interval_frequency]': frequency,
//       'properties[shipping_interval_unit_type]': units,
//       'properties[subscription_id]': SUBSCRIPTION_ID,
//     };
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data,
//       dataType: 'json',
//       success: () => {
//         window.location.href = '/cart';
//       },
//     });
//   },
//   translateShippingFrequency() {
//     const {key} = this.state.frequency || {};
//     if (!key) {
//       return null;
//     }
//     switch (key) {
//       case 'fortnightly':
//         return {
//           frequency: '14',
//           units: 'days',
//         };
//       case 'weekly':
//         return {
//           frequency: '7',
//           units: 'days',
//         };
//       default:
//         return {
//           frequency: '7',
//           units: 'days',
//         };
//     }

//   },
// };

// $(document).ready(function() {
//   const subscriptionJson = getJsonFromScriptTag("[data-selection-liquid]");
//   console.log(subscriptionJson);
//   subscription.init(subscriptionJson);
// });

